import React from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'

import SEO from '../../components/seo'
import Navbar from '../../components/navbar_poc'
import AboutTwo from '../../components/about-two'
import CtaOne from '../../components/cta/cta-one'
import Partner from '../../components/partner'
import PricingTwo from '../../components/pricing-two'
import Footer from '../../components/footer'
import AboutThree from '../../components/about-three'
import phoneImg from '../../assets/images/startup/whyindia2.jpg'
import ClientThree from '../../components/client-three'
import PodcastPlayer from '../../components/podcast-player'
import heroImg from '../../assets/images/cover5.png'
import { lawyerServices} from '../../data/data'
import { featureData, skillData, teamData } from '../../data/poc'
import ClientLogoSlider from '../../components/ClientLogoSlider'
import aboutImg2 from '../../assets/images/team/siva.png'
import ClientFour from '../../components/client-four'
import image1 from '../../assets/images/portfolio/customermap.png'
import image2 from '../../assets/images/portfolio/single02.jpg'
import image3 from '../../assets/images/portfolio/single03.jpg'
import bg1 from '../../assets/images/managment/whywestarted.jpg'
import { portfolioData, social } from '../../data/portfolio'
import VideoModalTwo from '../../components/video-modal-two'
import TinySlider from "tiny-slider-react";
import { about, footerLinks, footerPodcastRAW, footerSocialRAW, landing, location, serviceStages } from '../../data'
import 'tiny-slider/dist/tiny-slider.css';
import PodcastPlayer4 from '../../components/podcast-player4'
export default function IndexRootsAndWings() {

    const navigate = useNavigate();

    const handleSubmit = (e) => {
      e.preventDefault(); // prevent default form submission behavior
      navigate('/contact'); // redirect to /contact
    };
    let Images = [image1]
    const settings = {
        container: '.tiny-single-item',
            items: 1,
            controls: false,
            mouseDrag: true,
            loop: false,
            rewind: true,
            autoplay: false,
            autoplayButtonOutput: false,
            autoplayTimeout: 3000,
            navPosition: "bottom",
            speed: 400,
            gutter: 16,
      };
      let params = useParams();
      let id = params.id;
      let data = portfolioData.find((item)=>item.id === parseInt(id))
  return (
    <>
     <Navbar/> 
     <SEO
  title="Roots and Wings Podcast"
  description="A podcast about growth — personal, national, and global."
  url="https://www.pioneeroneglobal.com/podcast"
  image="https://www.pioneeroneglobal.com/images/option2.png"
/>

 
    <section className="bg-half-170 bg-light d-table w-100">
      <div className="container">
          <div className="row align-items-center mt-5">
              <div className="col-lg-6 col-md-5">
                  <div className="me-lg-5">
                      <img src={heroImg} className="img-fluid rounded" alt=""/>
                  </div>
              </div>

              <div className="col-lg-6 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
                  <div className="title-heading mt-4">
                      <h1 className="heading mb-3">Roots and Wings</h1>
                      <p className="para-desc text-muted">A podcast about growth - of people, companies and countries</p>
                      <p className="text-muted description">Roots and Wings is a podcast recorded by Siva Bala Narayanan — founder of Pioneer One Global, marathon runner, Gita student, and father of three.</p>

<p className="text-muted description">It explores what it takes to grow — as a person, as a company, and as a nation.</p>
<p className="text-muted description">Through personal stories, deep ideas, and reflections on India@2047, this podcast invites listeners to rethink their role in shaping the future.</p>
<p className="text-muted description">Subscribe to the podcast</p>

</div>
                                          <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                                <ul className="list-unstyled text-sm-end social-icon social mb-0">
                                                    {footerPodcastRAW.map((item,index)=>{
                                                        return(
                                                              <a
                                                              href={item.link}
                                                              target="_blank"
                                                              rel="noopener noreferrer"
                                                              className="podcast-button"
                                                            >
                                                              <img src={item.image} style={{ height: "36px" ,marginRight: "10px" }}alt="Podcasts" />
                                                              
                                                            </a>)})}
                                                </ul>
                                            </div>
                                                  <div className="d-flex mt-3">
                                                  {footerSocialRAW.map((item,index)=>{
                                                                                  let Icon = item.icon
                                                                                  
                                                                                  return(
                                                                                      <li className="list-inline-item m-x-2" key={index}><Link to={item.link} target="_blank" className="rounded"><i className=" align-middle"><Icon style={{ color: item.color, fontSize: "24px" }} /></i></Link></li>
                                                                                  )
                                                                              })}
                                                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section">
    <div className="container">
    <div className="row">
              <div className="col-12">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Opening Episode</h4>
                      <p className="text-muted ">In this opening episode of Roots and Wings, Siva Bala Narayanan explores what it truly means to grow — as a person, as a company, and as a country. Blending personal insight with philosophical depth, the episode introduces key themes like mindset change, swadharma, and India@2047. It’s a call to action for global Indians, well-wishers of India, and anyone who believes their story can shape the future.</p>
                      <PodcastPlayer4/>
                  </div>
                  {/* <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Don't miss an episode!</h4>
                      <p className="text-muted ">Get future episodes, bonus stories, and behind-the-scenes reflections from Siva straight to your inbox.</p>
                      <iframe
  src="https://solidcommonground.substack.com/embed"
  width="480"
  height="320"
  style={{
    border: '1px solid #EEE',
    background: 'white'
  }}
  frameBorder="0"
  scrolling="no"
/>
                 </div> */}

              </div>
          </div>
                <div className="container mt-4">
                      <div className="row justify-content-center">
                          <div className="col-lg-6 col-md-9 text-center">
                              <ClientFour/>
                          </div>
                      </div>
                  </div>
                  </div>
      </section>

    <section className="section">
    <div className="container">
    <div className="container mt-4">
          <div className="row align-items-center">
             <div className="col-md-5 order-1 order-md-2 text-center text-md-end">

                  <img src={aboutImg2} style={{ height: '300px' }} className="img-fluid shadow-lg rounded-top-pill rounded-bottom-5" alt=""/>
              </div>

              <div className="col-md-7 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title">
                      <h4 className="title mb-4">About the Author</h4>
                      <p className="text-muted">Siva Bala Narayanan is the founder of Pioneer One Global. Having spent half his life in India and the other half in the U.S., he helps global companies navigate the complexity and promise of India. A marathon runner, former chess coach, and lifelong student of the Bhagavad Gita, Siva believes that real growth — whether in business, personal life, or nation-building — begins with mindset, discipline, and inner clarity. As a parent of three daughters raised with both roots and wings, he now extends that philosophy through this podcast: an invitation to reflect, take responsibility, and shape India’s future story.</p>
                        <div className="mt-4">
                          <Link to="#" className="btn btn-outline-primary">More about Siva</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
               <div className="container mt-4">
                      <div className="bg-white rounded p-md-5 p-4 p-sm-0 shadow">
                          <div className="row align-items-center">
                              <div className="col-sm-7">
                                  <div className="text-sm-start">
                                      <h4>Helping You Grow with India</h4>
                                      <p className="text-muted description">This podcast is brought to you by Pioneer One Global — helping global companies explore, enter, and grow in India.</p>
                                      <p className="text-muted description">If you're a founder, operator, or executive thinking about India, we’d love to talk.</p>
                               
                                   </div>
                              </div>
            
                              <div className="col-sm-5 mt-4 mt-sm-0">
                                  <div className="text-sm-end">
                                      <Link to="/contact" className="btn btn-outline-primary"><i className="mdi mdi-phone-outline"></i> Get in touch!</Link>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
  {/* <ClientLogoSlider/> */}
  </div>
  </section>
    <Footer/>
    </>
  )
}
